
//top app bar
import {MDCTopAppBar} from '@material/top-app-bar';

// Instantiation
const topAppBarElement = document.querySelector('.mdc-top-app-bar');
const topAppBar = new MDCTopAppBar(topAppBarElement);

//menu
// menu.open = true;
import {MDCMenu} from '@material/menu';
window.MDCMenu = MDCMenu;

import {
    MDCMenuSurface
} from '@material/menu-surface';
window.MDCMenuSurface = MDCMenuSurface;

//buttons
import {MDCRipple} from '@material/ripple';
const iconsRipple = document.querySelectorAll(".mdc-icon-button");
for (const iconRipple of iconsRipple) {
    const iconButtonRipple = new MDCRipple(iconRipple);
    iconButtonRipple.unbounded = true;
}
//Buttons
const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
  return new MDCRipple(el);
});

//forms
import {MDCFormField} from '@material/form-field';
const formFields = document.querySelectorAll(".mdc-form-field");
for (const formField of formFields) {
    MDCFormField.attachTo(formField);
}

//Dawer
import { MDCDrawer } from "@material/drawer";
const drawer = MDCDrawer.attachTo(document.querySelector(".mdc-drawer"));

//Open drawer
topAppBar.listen("MDCTopAppBar:nav", () => {
    drawer.open = !drawer.open;
    document.body.classList.toggle("overflow-hidden");
});
//Close drawer
// const closeButton = document.getElementById("close-drawer");
// closeButton.addEventListener("click", () => {
//     console.log('clicked');
//     console.log(drawer);

//     drawer.open = false;
// });
//Toggle disable scroll when modal opened
document.body.addEventListener("MDCDrawer:closed", () => {
    document.body.classList.toggle("overflow-hidden");
});

import {MDCIconButtonToggle} from '@material/icon-button';
document.querySelectorAll('.mdc-icon-toggle').forEach(element => MDCIconButtonToggle.attachTo(element));
